<template>
  <div>
  <template v-if="loading === false">
    <div class="row status-wrapper">
      <div id="corpo" class="col s12 m8 offset-m2 border-color-pri scale-transition z-depth-1">
        <div v-if="status == 'done'" class="col s12 finalizado">
          <h5>Cadastro consolidado!</h5>
          <p>
            <br />
            <span>{{ formataValidHash(valid_data.validation_hash) }}</span>
            <br />
            Protocolo
          </p>
          <p>
            <br />
            <span>{{ converteData(valid_data.data_hora) }}</span>
            <br />
            Data/Hora
          </p>
          <p>
            <br />
            <span>{{ valid_data.nome }}</span>
            <br />
            Resposável técnico
          </p>
          <br />
          <a @click="downloadComprovante" class="waves-effect waves-light btn">Download do comprovante</a>
        </div>
        <div v-else class="col s12 espera">
          <h5>Agora é com a gente!</h5>
          <p>Seu cadastro está em processo de verificação e em breve você será notificado sobre o status da validação dos dados</p>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="loading-wrapper">
      <loading />
    </div>
  </template>
  </div>
</template>
<script>
import axios from 'axios' //5350746737874881475

import Loading from '@/components/Loading.vue'
import {formataData, converteTimestamp, converteData} from '@/assets/js/form-utils.js'
import SocialService from '@/services/social-service.js'

import {CONFIG} from '@/config/config.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Status',
  components: {
    loading: Loading
  },
  data (){
    return {
      pf_id: this.$store.state.user.pfId,
      oid: this.$store.state.user.oid,
      status: null,
      valid_data: {},
      loading: true,
      converteData: converteData,
    }
  },
  methods: {
    goToHome(){
      if (this.$route.path !== '/') {
        this.$router.push('/Censo/')
      }
    },
    verificaStatusCadastro(){
      axios.get(`${CONFIG.URL_RECAD_API_V2}/v1/higienize-segurado/${this.pf_id}/`)
      .then((response) => {
        
        if(response.data.data.RecadAPI.status === 'done'){
          this.valid_data = response.data.data.RecadAPI

          // Recupera o nome do higienizador
          socialService.exchange([response.data.data.RecadAPI.uupfid], ['nome', 'cpf',], true)
          .then((social_data) => {
            this.$set(this.valid_data, 'nome', social_data[this.valid_data.uupfid]['nome'])
          })

        } else if(response.data.data.RecadAPI.status === 'released') {
          this.$router.push('/Review/')
        }
        this.status = response.data.data.RecadAPI.status
        this.loading = false
      })
      .catch((error) => {
        //Cadastro não submetido
        if(error.response.status === 404){
          this.$router.push('/Censo/')
        }
      })
    },
    downloadComprovante(){
      this.loading = true
        axios.get(`${CONFIG.URL_RECAD_API_V2}/v1/validate/${this.pf_id}/report/`)
        .then((response) => {
          document.location.href = response.data.data.RecadAPI.url_file
        })
        .catch((error) => {
          M.toast({html: 'Ops! Não foi possível atender a esta solicitação neste momento...Verifique a sua conexão com a internet e tente novamente em instantes.'})
        })
        .finally(() => {
          this.loading = false
        })
    },
    formataValidHash(hash){
      return hash.toUpperCase().replace(/(.{2})(.{2})(.{2})(.{2})(.{2})(.{2})/g, '\$1-\$2-\$3\-\$4-\$5-\$6')
    }
  },
  mounted(){
    this.$root.$emit('stopLoadingHeader')
    this.verificaStatusCadastro()
  }
}
</script>
<style scoped>
  p {
    margin: 0 5px 0px 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Status.vue